import { ZoomIn } from '@mui/icons-material';
import {TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper, IconButton} from '@mui/material';
import moment from 'moment';
import Docs from './Docs';
import { useState } from 'react';
import { txt } from '../../../services/translation';

export default function Enrollments({data}){

    const [docs, setDocs] = useState(false)

    return <>
        
        <TableContainer component={Paper} variant='outlined'>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>{txt('training')}</TableCell>
                        <TableCell>{txt('type')}</TableCell>
                        <TableCell>{txt('date')}</TableCell>
                        <TableCell>{txt('cost')}</TableCell>
                        <TableCell>{txt('completion')}</TableCell>
                        <TableCell>{txt('dpc')}</TableCell>
                        <TableCell>{txt('documents')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.enrollments.map(e => 
                        <TableRow key={e.id}>
                            <TableCell>{e.course?.title}</TableCell>
                            <TableCell>{e.type?.title}</TableCell>
                            <TableCell>{moment(e.createdAt).format('DD/MM/YYYY')}</TableCell>
                            <TableCell>{e.amount.toLocaleString()}<small>€</small></TableCell>
                            <TableCell>{e.completion}<small>%</small></TableCell>
                            <TableCell>{e.dpc?.title}</TableCell>
                            <TableCell align='center'>
                                <IconButton size='small' onClick={() => setDocs(e)}>
                                    <ZoomIn />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>

        <Docs 
            enrollment={docs}
            open={docs ? true : false}
            onClose={() => setDocs(false)}
        />

    </>
}